import Colours from './Colours';
import { Theme } from '../../../types/theme';

export function btnBg(theme: Theme) {
  return theme.brand.button_background_colour;
}

export function btnText(theme: Theme) {
  return theme.brand.button_text_colour;
}

export function accent(theme: Theme) {
  return theme.brand.accent_colour;
}

export function isDisplayedInIframe(theme: Theme) {
  return theme.brand.iframe === true;
}

export function logoAlignment(theme: Theme) {
  return theme.brand.logo_alignment;
}

export function headerLogo(theme: Theme) {
  return theme.brand.header_logo;
}

export function headerBg(theme: Theme) {
  return theme.brand.header_background_colour;
}

export default {
  brand: {
    accent_colour: Colours.primary,
    button_background_colour: Colours.primary,
    button_text_colour: Colours.white,
    header_background_colour: Colours.primary,
    header_logo: '',
    favicon: '',
    logo_alignment: 'center',
    iframe: false,
  },
  flexboxgrid: {
    // Defaults
    gridSize: 12,
    gutterWidth: 1.25,
    outerMargin: 1.25,
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 50,
      lg: 50,
    },
    breakpoints: {
      xs: 0,
      sm: 48,
      md: 64,
      lg: 75,
    },
  },
};
